import qs from 'qs';

import { get, post } from '@/services/Axios';
import errorHandler from '@/mixins/errorHandler';

export default {
  mixins: [errorHandler],

  data() {
    return {
      events: [],
      event: {},
      paginationEvents: {},
      loadEvents: true,
      loadFormEvent: false,
      loadEvent: false
    };
  },

  methods: {
    async getEvents(...param) {
      this.loadEvents = true;
      const parameter = param[0] || {};
      const params = {
        limit: parameter.limit || 10,
        page: parameter.page || 1,
        sort: parameter.sorts || 'event_created_datetime',
        dir: parameter.dir || 'DESC',
        filter: []
      };
      if (parameter.filters) {
        params.filter.push(...parameter.filters);
      }
      try {
        const {
          data: { results, pagination }
        } = await get('/event/list', { params });
        this.events = results;
        this.paginationEvents = pagination;
        return results;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadEvents = false;
      }
    },

    async getEvent(id) {
      this.loadEvent = true;
      const params = {
        event_id: id
      };
      try {
        const { data } = await get('/event/detail', { params });
        this.event = data;
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadEvent = false;
      }
    },

    async createEvent(request) {
      this.loadFormEvent = true;
      const requestBody = {
        name: request.name,
        date: request.date,
        content: request.content,
        participant: request.participant,
        location: request.location,
        latitude: request.latitude,
        longitude: request.longitude,
        attachment: request.attachment, //optional
        type: request.type //optional
      };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/event/create', { data: payload });
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormEvent = false;
      }
    },

    async updateEvent(request, id) {
      this.loadFormEvent = true;
      const requestBody = {
        event_id: id,
        name: request.name,
        date: request.date,
        content: request.content,
        participant: request.participant,
        location: request.location,
        latitude: request.latitude,
        longitude: request.longitude,
        attachment: request.attachment, //optional
        type: request.type //optional
      };
      const payload = qs.stringify(requestBody);
      try {
        const { data } = await post('/event/update', { data: payload });
        return data;
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormEvent = false;
      }
    },

    async deleteEvent(id) {
      this.loadFormEvent = true;
      try {
        await get(`/event/delete?event_id=${id}`);
      } catch (e) {
        throw this.handleError(e);
      } finally {
        this.loadFormEvent = false;
      }
    }
  }
};
